module.exports = __webpack_public_path__ + "static/media/Logo RudeRuth (Black).38a263ad.png";